import { UnsavedChangesDialog } from '~/components/UnsavedChangesDialog/UnsavedChangesDialog';
import { type FormState, type FieldValues } from 'react-hook-form';
import { useBlocker } from 'react-router';
import { useEffect } from 'react';

export function useUnsavedChangesGuard<T extends FieldValues>(
  formState: Pick<FormState<T>, 'dirtyFields' | 'isSubmitting' | 'isSubmitSuccessful'>
) {
  const shouldBlock =
    Object.keys(formState.dirtyFields).length > 0 &&
    !formState.isSubmitting &&
    !formState.isSubmitSuccessful;

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      shouldBlock && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (!shouldBlock) return;

    function handler(event: BeforeUnloadEvent) {
      event.preventDefault();
      event.returnValue = '';
    }

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [shouldBlock]);

  const dialog = (
    <UnsavedChangesDialog
      isOpen={blocker.state === 'blocked'}
      onClose={() => blocker.reset?.()}
      onConfirm={() => blocker.proceed?.()}
    />
  );

  return { dialog };
}
